import Cell from "./ProductionTableCell.js";
import Operation from "./Operation.js";
export default class Row {
  constructor(row) {
    this.type = row.type;
    this.cells = Array.isArray(row.cells) ? row.cells : [];
    this.object = row.object;
  }

  setType(type) {
    this.type = type;
  }

  setCells(cells) {
    this.cells = cells;
  }

  setObject(object) {
    this.object = object;
  }

  getType() {
    const object = this.object;
    if (!object) return;
    if ("count" in object) {
      return "order"
    }
    return "product";
  }

  static getRows(orders, workCenters, preperation, suppliers) {
    if (preperation) {
      orders.sort((a, b) => {
        const dateA = new Date(a.delivery_date);
        const dateB = new Date(b.delivery_date);
        //get oldest first
        return dateA.getTime() - dateB.getTime();
      });
    }
    const rows = [];
    orders.forEach(order => {
      rows.push(Row.getOrderRow(order, workCenters, preperation, suppliers));
      if (order.showProducts) {
        for (const product of order.products) {
          rows.push(Row.getProductRow(product, workCenters, order, preperation, suppliers));
        }
      }
    });
    return rows;
  }

  static getOrderRow(order, workCenters, preperation, suppliers) {
    const orderSymbol = order.showProducts ? "-" : "+";
    const row = new Row({ type: "order", object: order });
    //create cells with correct numbers
    const orderCells = [
      new Cell({
        name: "production_id",
        number: 0,
        text: `${orderSymbol} ${order.toString()}`,
        style: {
          "name-cell": true
        }
      }),
      new Cell({
        name: "customer_name",
        number: 1,
        text: order.customer.toString(),
        style: {
          "customer-cell": true
        }
      })
    ];
    if (preperation) {
      orderCells.push(new Cell({
        name: "manager_name",
        number: orderCells.length,
        text: order.getManagerName(),
        style: {
          "manager-cell": true
        }
      }))
      orderCells.push(new Cell({
        name: "product_type",
        number: orderCells.length,
        text: order.product_type,
        style: {
          "type-cell": true
        }
      }))
      orderCells.push(new Cell({
        name: "products_area",
        number: orderCells.length,
        text: order.getArea(),
        style: {
          "area-cell": true,
          "number-cell": true
        }
      }))
      orderCells.push(new Cell({
        name: "wood_type",
        number: orderCells.length,
        text: order.wood_type,
        style: {
          "wood-cell": true
        }
      }))
      orderCells.push(new Cell({
        name: "paint_type",
        number: orderCells.length,
        text: order.paint_type,
        style: order.getPaintStyle()
      }))
      orderCells.push(new Cell({
        name: "element_count",
        number: orderCells.length,
        text: order.element_count,
        style: {
          "element-cell": true,
          "number-cell": true
        }
      }))
      orderCells.push(new Cell({
        name: "spross_count",
        number: orderCells.length,
        text: order.spross_count,
        style: {
          "spross-cell": true,
          "number-cell": true
        }
      }))
      //add columns for suppliers
      suppliers.forEach((supplier) => {
        orderCells.push(
          new Cell({
            name: `supplier_${supplier.id}`,
            number: orderCells.length,
            date_cell: true,
            related_supplier: supplier,
            suppliers: order.suppliers.filter(e => {
              return e.supplier_id == supplier.id;
            }),
            text: order.getSupplierDate(supplier),
            style: {
              "supplier-cell": true
            }
          })
        )
      });
      orderCells.push(
        new Cell({
          name: "other_suppliers",
          number: orderCells.length,
          date_cell: true,
          other: true,
          text: order.getOtherSuppliersDate(suppliers),
          suppliers: order.orderGetOtherSuppliers(suppliers),
          style: {
            "supplier-cell": true
          }
        })
      )
    }
    //get cells for working centers
    for (let i = 1; i <= workCenters.length; i++) {
      //add to array correct place
      const operations = order.getWorkCenterOperations(workCenters[i - 1].id);
      let cellText = operations.length > 0 ? "" : "-"
      const style = Operation.getCenterStyle(order.products, workCenters[i - 1].id);
      let customStyle = "";
      if (style['uncompleted-box'] === true) {
        const completedOperations = Operation.getCompletedOperations(operations);
        if (completedOperations.length != operations.length && completedOperations.length > 0) {
          const completedPercent = Math.round(completedOperations.length / operations.length * 100);
          const uncompletedPercent = 100 - completedPercent;
          cellText = `${completedPercent}%`
          customStyle = this.getCustomStyle(completedPercent, uncompletedPercent, 'rgb(109, 185, 109)', 'rgb(248, 248, 106)')
        }
      }
      orderCells.splice(
        i + 1,
        0,
        new Cell({
          number: orderCells.length,
          text: cellText,
          style: style,
          custom_style: customStyle,
          workCenterId: workCenters[i - 1].id
        })
      );
    }
    if (preperation) {
      orderCells.push(new Cell({
        name: "predicted_date",
        number: orderCells.length,
        text: order.getPossibleStartDate(workCenters),
        style: order.getPossibleStartDateStyle(workCenters)
      }))
    }
    orderCells.push(new Cell({
      name: "due_date",
      number: orderCells.length,
      text: preperation ? order.delivery_date : order.getCompletionDate(),
      style: {
        'completion-date-cell': true
      }
    }))
    //if preperation, add another column for checkbox
    if (preperation) {
      orderCells.push(
        new Cell({
          number: -1,
          text: "",
          style: {
            "checkbox-cell": true
          }
        })
      )
    }
    orderCells.sort((a, b) => {
      return a.number - b.number;
    });
    row.setCells(orderCells);
    return row;
  }

  static getProductRow(product, workCenters, order, preperation, suppliers) {
    const positionProducts = order.products.filter(orderProduct => {
      return product.position == orderProduct.position;
    });
    const productIndex = positionProducts.indexOf(product);
    const indexText = positionProducts.length > 1 ? `${productIndex + 1}/${positionProducts.length}` : "";
    const row = new Row({ type: "product", object: product });
    const productCells = [
      new Cell({
        number: 0,
        text: `--Poz. ${product.position} ${indexText}`,
        style: {
          "name-cell": true
        }
      }),
      new Cell({
        number: 1,
        text: `${product.dimensions()} ${product.type}`,
        style: {
          "name-cell": true
        }
      }),
    ];
    if (preperation) {
      productCells.push(new Cell({
        number: productCells.length,
        text: "",
        style: {
          "manager-cell": true
        }
      }))
      productCells.push(new Cell({
        number: productCells.length,
        text: "",
        style: {
          "type-cell": true
        }
      }))
      productCells.push(new Cell({
        number: productCells.length,
        text: product.area,
        style: {
          "area-cell": true,
          "number-cell": true
        }
      }))
      productCells.push(new Cell({
        number: productCells.length,
        text: "",
        style: {
          "wood-cell": true,
        }
      }))
      productCells.push(new Cell({
        number: productCells.length,
        text: "",
        style: {
          "paint-cell": true
        }
      }))
      productCells.push(new Cell({
        number: productCells.length,
        text: "",
        style: {
          "element-cell": true
        }
      }))
      productCells.push(new Cell({
        number: productCells.length,
        text: "",
        style: {
          "spross-cell": true
        }
      }))
      //add columns for suppliers
      for (let i = 0; i < suppliers.length; i++) {
        productCells.push(
          new Cell({
            number: productCells.length,
            text: '',
            style: {
              "supplier-cell": true
            }
          })
        )
      }
      productCells.push(
        new Cell({
          number: productCells.length,
          text: "",
          style: {
            "supplier-cell": true
          }
        })
      )
    }
    for (let i = 1; i <= workCenters.length; i++) {
      const operations = product.getWorkCenterOperations(workCenters[i - 1].id);
      const cellText = operations.length > 0 ? "" : "-"
      productCells.splice(
        i + 1,
        0,
        new Cell({
          number: productCells.length,
          text: cellText,
          style: Operation.getCenterStyle([product], workCenters[i - 1].id),
          workCenterId: workCenters[i - 1].id
        })
      );
    }
    if (preperation) {
      productCells.push(new Cell({
        number: productCells.length,
        text: "",
        style: {
          'completion-date-cell': true
        }
      }))
    }
    productCells.push(new Cell({
      number: productCells.length,
      text: preperation ? order.delivery_date : new Date(product.completion_date).toLocaleDateString("lt-LT"),
      style: {
        'completion-date-cell': true
      }
    }))
    //if preperation, add another column for checkbox
    if (preperation) {
      productCells.push(
        new Cell({
          number: -1,
          text: "",
          style: {
            "checkbox-cell": true
          }
        })
      )
    }
    productCells.sort((a, b) => {
      return a.number - b.number;
    });
    row.setCells(productCells);
    return row;
  }

  static getCustomStyle(completedPercent, uncompletedPercent, finishedColor, unfinishedColor) {
    return {
      background: `linear-gradient(to right, ${finishedColor} ${completedPercent}%, ${unfinishedColor} ${completedPercent}% ${uncompletedPercent}%)`
    }
  }
}
